/**
 * MyDay shared constants — BUCKET_CONFIG, STATUS_INDICATORS, ITEM_TYPE_ICONS
 */
import {
  FlaskConical, MessageSquare, FileText, TestTubes, ScanLine,
  Stethoscope, FileBarChart, ArrowRight, Pill
} from 'lucide-react';

export const BUCKET_CONFIG = {
  messages:      { label: 'Messages',      icon: MessageSquare, color: 'hsl(213, 78%, 44%)' },
  prescriptions: { label: 'Prescriptions', icon: Pill,          color: 'hsl(280, 50%, 50%)' },
  lab_xray:      { label: 'Labs / Imaging',icon: FlaskConical,  color: 'hsl(173, 45%, 36%)' },
  my_documents:  { label: 'My Documents',  icon: FileText,      color: 'hsl(27, 80%, 50%)'  },
  delegated:     { label: 'Delegated',     icon: ArrowRight,    color: 'hsl(213, 60%, 55%)' },
};

export const STATUS_INDICATORS = {
  ready:       { dot: 'bg-emerald-400', label: 'In Visit' },
  pending:     { dot: 'bg-amber-400',   label: 'Pending' },
  not_arrived: { dot: 'bg-rose-400',    label: 'Not Arrived' },
  completed:   { dot: 'bg-slate-300',   label: 'Completed' },
};

export const ITEM_TYPE_ICONS = {
  lab_result:        TestTubes,
  imaging_result:    ScanLine,
  pathology_report:  FileBarChart,
  nurse_note:        MessageSquare,
  internal_message:  MessageSquare,
  provider_fyi:      MessageSquare,
  callback_request:  MessageSquare,
  referral_note:     Stethoscope,
  consult_note:      Stethoscope,
  outside_record:    FileText,
  discharge_summary: FileText,
};
